import { PartialNullable } from "../../Extensions";
import { Property } from "../../RadObject";
import { IPropertyEditor, PropertyEditor, PropertyEditorPropertyValues } from "../Controls/PropertyEditor";
import { Text } from "./Text";
import { NAMESPACE } from "./_Namespace";

export type PropertyEditorTextPropertyValues =
    PropertyEditorPropertyValues
    & {
    };

export type PropertyEditorTextProperties = {
    [name in keyof PropertyEditorTextPropertyValues]: Property<PropertyEditorTextPropertyValues[name]>
};

export interface IPropertyEditorText extends IPropertyEditor, PropertyEditorTextProperties
{
}

export class PropertyEditorText extends PropertyEditor implements IPropertyEditorText
{
    // #region Static

    public static override classNamespace = NAMESPACE + "PropertyEditorText";
    public static override className = "PropertyEditorText";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<PropertyEditorTextPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                createEditorControl: () => new Text(),
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructor

    constructor(propertyValues?: PartialNullable<PropertyEditorTextPropertyValues>)
    {
        super(propertyValues);

        this.addCssClass("rad-control-property-editor-text");
    }

    // #endregion

    // #endregion
}
